module.exports = __webpack_public_path__ + "img/rules_8.9f236fbd.png";